import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { JobLog } from '../models/job-log.model';
import { JobLogsService } from '../job-logs.service';
import { ApiResponse } from '../../../../shared/models/apiResponse.model';

@Component({
  selector: 'app-job-log-detail-modal',
  templateUrl: './job-log-detail-modal.component.html',
  styleUrls: ['./job-log-detail-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JobLogDetailModalComponent {
  @ViewChild('jobDetailModal') jobDetailModalElement: ElementRef;
  private jobDetailModal: NgbModalRef;
  public jobLog: JobLog = null;
  public isRefreshing = false;

  constructor(
    private modalService: NgbModal,
    private jobLogsService: JobLogsService,
    private toastrService: ToastrService
  ) { }

  open(jobLog: JobLog){
    this.jobLog = jobLog;
    this.isRefreshing = false;

    const modalConfig: NgbModalOptions = {
      container: '.app',
      size: <any>'xl',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'job-log-detail-modal',
    };

    this.jobDetailModal = this.modalService.open(this.jobDetailModalElement, modalConfig);
  }

  close() {
    this.jobLog = null;
    this.jobDetailModal.close();
  }

  refresh() {
    if (!this.jobLog || this.isRefreshing) {
      return;
    }

    this.isRefreshing = true;
    const requestedJobId = this.jobLog.id;

    this.jobLogsService.getJobLogById(requestedJobId)
      .subscribe(
        (resp: ApiResponse<JobLog>) => {
          if (!this.jobLog || this.jobLog.id !== requestedJobId) {
            return;
          }

          if (resp.data) {
            this.jobLog = resp.data;
          }

          if (!resp.successful && resp.message) {
            this.toastrService.error(resp.message);
          }

          this.isRefreshing = false;
        },
        (err) => {
          if (!this.jobLog || this.jobLog.id !== requestedJobId) {
            return;
          }

          console.error(err);
          this.toastrService.error(this.getRefreshErrorMessage(err));
          this.isRefreshing = false;
        }
      );
  }

  private getRefreshErrorMessage(err: any): string {
    if (err) {
      if (err.status === 404) {
        return 'This job log no longer exists.';
      }

      const serverError = err.error;
      if (typeof serverError === 'string' && serverError) {
        return serverError;
      } else if (serverError && (serverError.detail || serverError.message)) {
        return serverError.detail || serverError.message;
      }
    }

    return 'Failed to refresh job log.';
  }

  getTimestampString(timestamp: Date) {
    const date = new Date(timestamp);
    const utcDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

    return `${utcDate.toLocaleDateString()} ${utcDate.toLocaleTimeString()}`;
  }
}






// WEBPACK FOOTER //
// ./src/app/developer/logs/job-logs/job-log-detail-modal/job-log-detail-modal.component.ts